export default "__VITE_ASSET__BjMXs7xP__"